import { Box, Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import CommonTable from 'components/common/CommonTable';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { axios } from 'utils/axios';
import { CheckCircle, Cancel, LocationOn } from '@mui/icons-material';
import useSettings from 'hooks/useSettings';
import { Container } from '@mui/material';

const ContactSites = () => {
  const navigate = useNavigate();
  const [contactSties, setContactSites] = useState<any>([]);
  const { themeStretch } = useSettings();

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const { id = '' } = useParams();

  const columns = [
    // { field: 'Id', headerName: 'ID', width: 150 },
    { field: 'Name', headerName: 'Site Name', flex: 1, minWidth: 200 },
    { field: 'ContactName', headerName: 'Contact Name', flex: 1, minWidth: 200 },
    { field: 'Telephone', headerName: 'Telephone', flex: 1, minWidth: 200 },
    { field: 'Email', headerName: 'Email', flex: 1, minWidth: 200 },
    { field: 'add_line1', headerName: 'Address', flex: 2, minWidth: 300 },
    // { field: 'longitude', headerName: 'Longitude', width: 200 },
    // { field: 'latitude', headerName: 'Latitude', width: 150 },
    { field: 'CouncilArea', headerName: 'Council Area', flex: 1, minWidth: 250 },
    { field: 'SiteStatus', headerName: 'Status', width: 150 },
    {
      field: 'SiteTypeCollection',
      headerName: 'Collection',
      minWidth: 150,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    },
    {
      field: 'SiteTypeDisposal',
      headerName: 'Disposal',
      minWidth: 150,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    },
    {
      field: 'SiteTypeMRF',
      headerName: 'Recycling Plant',
      minWidth: 200,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    },
    {
      field: 'SiteTypeLandfill',
      headerName: 'Landfill',
      minWidth: 150,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    }
    // { field: 'SiteTypeOther', headerName: 'Other Type', flex: 1, minWidth: 200 }
    // { field: 'AddedAt', headerName: 'Added At', width: 200 },
    // { field: 'UpdatedAt', headerName: 'Updated At', width: 200 }
  ];

  const handleCreateContact = () => {
    navigate(`/dashboard/sites/new/${id}`);
  };

  const handleRowClick = (params: any) => {
    navigate(`/dashboard/sites/details/${params.row.Id}`);
  };

  const handleEdit = (id: number) => {
    navigate(`/dashboard/sites/edit/${id}`);
  };

  const fetchContactSites = async () => {
    try {
      setLoading(true);

      const clientIdParam = id ? `clientId=${id}&` : '';
      const response = await axios.get(
        `/rest/api/contacts/sites?${clientIdParam}page=${page}&pageSize=${pageSize}`
      );

      const data = response?.data?.data || {};
      const contactSites = data || [];
      const totalRecords = response?.data?.pageMeta?.totalRecords || 0;

      setContactSites(contactSites);
      setTotalRows(totalRecords);
    } catch (error) {
      console.error('Error fetching contact sites:', error);
      setContactSites([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteContact = async (id: number) => {
    try {
      await axios.delete(`/rest/api/contacts/sites/${id}`);
      const newContacts = contactSties.filter((el: any) => el.Id !== id);
      setContactSites(newContacts);
      enqueueSnackbar('Delete Success', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Delete Failed', { variant: 'success' });
    }
  };
  useEffect(() => {
    fetchContactSites();
  }, [page, pageSize]);

  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            marginBottom: 5
          }}
        >
          <Button variant="contained" onClick={handleCreateContact} startIcon={<LocationOn />}>
            Create Site
          </Button>
        </Box>
        <Box>
          {contactSties?.length ? (
            <CommonTable
              rows={contactSties}
              columns={columns}
              totalRecords={totalRows}
              pageSize={pageSize}
              loading={loading}
              handlePageChange={(newPage) => setPage(newPage + 1)}
              handlePageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              onEdit={handleEdit}
              onDelete={(id) => handleDeleteContact(id)}
              onRowClick={handleRowClick}
            />
          ) : !loading && contactSties.length == 0 ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <span>No Data Available</span>
            </div>
          ) : (
            ''
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default ContactSites;
